// Funnel loaders for the EAS English webinar funnel.

export const webinarDetailsLoader = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/webinarDetailsLoader");
    return module.webinarDetailsLoader ? await (module.webinarDetailsLoader as any)(args) : null;
};

export const sessionIdLoader = async (args: any) => {
    const module = await import("../util/TrackingUtil");
    return module.sessionIdLoader ? await (module.sessionIdLoader as any)(args) : null;
};
